import { DataCache, DataCacheCollection, SharedKeyRelationship, QueryResultsRelationship, QueryResultRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';

import { InitialData } from 'data/models/InitialData';
import { PilotsInitialData } from 'data/models/PilotsInitialData';
import { AuthorizedData } from 'data/models/AuthorizedData';
import { DomainSummary } from 'data/models/DomainSummary';
import { UserSummary } from 'data/models/UserSummary';

export class BootstrapCache extends DataCache {
    InitialData = PCCollection(InitialData);
    PilotsInitialData = PCCollection(PilotsInitialData);
    AuthorizedData = PCCollection(AuthorizedData);
    DomainSummaries = PCCollection(DomainSummary);
    UserSummaries = PCCollection(UserSummary);

    constructor(data : PCCache) {
        super();

        new QueryResultRelationship (this.InitialData,     this.UserSummaries,   d => d.UserSummary);
        new SharedKeyRelationship   (this.InitialData,     this.DomainSummaries, a => a.DomainSummary, null);
        new SharedKeyRelationship   (this.InitialData,     data.Domains,         a => a.Domain,        null);
        new QueryResultsRelationship(this.InitialData,     data.Countries,       a => a.Countries);
        new QueryResultsRelationship(this.InitialData,     data.Roles,           a => a.Roles);
        new QueryResultsRelationship(this.InitialData,     data.UIThemes,        a => a.UIThemes);
        new QueryResultsRelationship(this.InitialData,     data.AutomationSystems, d => d.AutomationSystems);
        new QueryResultsRelationship(this.InitialData,     data.MilestoneTypes,  d => d.MilestoneTypes);
        new QueryResultsRelationship(this.InitialData,     data.CoordinationCardStatuses, d => d.CoordinationCardStatuses);
        new SharedKeyRelationship   (this.AuthorizedData,  data.Domains,         d => d.Domain,        null);
        new QueryResultRelationship (this.AuthorizedData,  this.UserSummaries,   d => d.UserSummary);
        new SharedKeyRelationship   (this.DomainSummaries, data.DomainSettings,  d => d.Settings,      null);

        new SharedKeyRelationship   (this.PilotsInitialData, this.InitialData,   pd => pd.InitialData, d => d.Pilots)
        new QueryResultsRelationship(this.PilotsInitialData, data.PilotAgencies, pd => pd.PilotAgencies);
        new QueryResultsRelationship(this.PilotsInitialData, data.Pilots,        pd => pd.Pilots);
    }
}


// WEBPACK FOOTER //
// ./apps/core/app/bootstrapCache.ts